import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const options = {
   theme: {
      dark: false,
      default: 'light',
      options: {
         customProperties: true
      },
      themes: {
         light: {
            primary: '#e20074',
            secondary: '#8b8b8b',
            accent: '#9c27b0',
            error: '#f44336',
            warning: '#ff5722',
            info: '#3f51b5',
            success: '#4caf50',
            grey_light: '#f5f5f5',
            grey_dark: '#565656',
            accent_border: '#8c8c8c',
            primary_light: '#ec3875',
            yellow: '#EEFF41',
            orange: '#FB8C00',
         }
      },
   },
   icons: {
      iconfont: 'mdi', // default - only for display purposes
   },
}

export default new Vuetify(options)
